import { alpha, Card, CardContent, Typography } from '@mui/material';

type TotalizationCardProps = {
  title: string;
  value: string;
  bgColor: string;
  borderColor: string;
  color: string;
};

export function TotalizationCard({
  title,
  value,
  bgColor,
  borderColor,
  color,
}: TotalizationCardProps) {
  return (
    <Card
      variant="outlined"
      sx={{
        flex: 1,
        minWidth: 120,
        borderRadius: 2,
        bgcolor: (theme) => alpha(bgColor, 0.06),
        borderColor: (theme) => alpha(borderColor, 0.15),
      }}>
      <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
        <Typography
          variant="caption"
          sx={{
            color,
            textTransform: 'uppercase',
            fontWeight: 600,
            letterSpacing: 0.5,
          }}>
          {title}
        </Typography>
        <Typography variant="h4" fontWeight="bold" color="text.primary">
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}
